module.exports = __webpack_public_path__ + "images/emoji/rice_cracker.58e7922ad1aba876d9f5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rice_cracker.png
// module id = meGM
// module chunks = 24